import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { getShipName } from "../Actions/ShipViewAPI";
import { getShipnameList } from "../Actions/HelpersAPI";
import { searchCrewMgmt } from "../Actions/CrewManagement";
import swal from "sweetalert";
import axios from "axios";
import API from "../helpers/api";
import logo from "../Asset/download.jpg";
import Role from "../helpers/role";
import Autocomplete from "react-autocomplete";
import "../App.css";
import { getAllRank } from "../Actions/RankManagementAPI";
import { toast } from "react-toastify";
import * as $ from "jquery";
import { display } from "@mui/system";
import Modal from "react-bootstrap/Modal";
import Demo from "./croppercdn";
import { hideLoader } from "../Actions/PageLoaderAPI";


const SearchItem = {
  crewId: "",
  name: "",
  shipName: "",
  designation: "",
  clientId: 0,
  fromDate: "",
  toDate: "",
  designation: "",
  ImgSrc: "",
  shipId: 0,
  PageNumber: 1,
  PageSize: 25,
};

let userRole = localStorage.getItem("UserRoles");

class AddCrewMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      attachmentName: "",
      user: JSON.parse(localStorage.getItem("currentUser")),
      fileName: "",
      PhotoFile: "",
      searchData: {
        shipName: "",
        shipId: 0,
        clientId: 0,
        crewId: "",
        name: "",
        designation: "",
        photo: "",
        photoName: "",
        createdBy: "staff",
        modalIsOpen: false,
        fileName: "",
      },
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleInputFileChange = this.handleInputFileChange.bind(this);
  }
  componentDidMount() {
    this.props.dispatch(getShipnameList());
    this.props.dispatch(getShipName());
    this.props.dispatch(getAllRank());
    //this.props.dispatch(getMMPLUsersList(searchData));
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    const { shipInfo } = nextProps;
    // if (shipInfo) {
    //   prevState.searchData.shipName = shipInfo.shipName;
    // }
  }
  handleInputChange(e) {
    this.state.searchData[e.target.name] = e.target.value;
    this.setState({});
  }

  handleInputFileChange(event) {
    let _this = this;
    let filename = event.target.files[0].name;
    this.state.fileName = filename;
    this.state.ImgSrc = event.target.files[0];
    this.state.modalIsOpen = true;
    _this.setState({})
  }

  getBlobData = (file) => {
    this.setState({
      modalIsOpen: false
    })
    let finalResult = file.split(",");
    this.state.PhotoFile = file;
    this.state.searchData["photo"] = finalResult[1];
    this.state.searchData["photoName"] = this.state.fileName;
    this.setState({});
    this.props.dispatch(hideLoader());
  }

  propsImgSrc = (imgrsc) => {
    this.getBlobData(imgrsc);
  }

  SubmitCrew = () => {
    const { dispatch, history, shipInfo, ShipNameList } = this.props;
    if (userRole == Role.mmpladmin) {
      if (this.state.searchData.crewId !== "" && this.state.searchData.shipName !== "" && this.state.searchData.name !== "" && this.state.searchData.designation !== "" && this.state.searchData.photoName !== "") {
        let data = {
          shipName: userRole == Role.mmpladmin ? this.state.searchData.shipName : userRole == Role.staff ? ShipNameList[0]?.shipName : shipInfo.shipName,
          crewId: this.state.searchData.crewId,
          shipId: userRole == Role.mmpladmin ? this.state.searchData.shipId : userRole == Role.staff ? ShipNameList[0]?.shipID : shipInfo.shipId,
          name: this.state.searchData.name,
          designation: this.state.searchData.designation,
          photo: this.state.searchData.photo,
          photoName: this.state.searchData.photoName,
          createdBy: this.state.user.email,
        };

        let url = `${API.PostCrew}`;
        axios
          .post(url, data)
          .then((response) => {
            if (response.status === 500) {
              swal("Error!", "Error when adding the data. Try again.", "warning");
            } else if (response.status === 400) {
              swal("Error!", response.data, "warning");
            }
            else if (response.status === 200) {
              dispatch(searchCrewMgmt(SearchItem, 1));
              this.moveClientList();
              toast.success("Added Successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          })
          .catch((error) => {
            if (error.response.status === 400) {
              swal("Error!", error.response.data, "warning");
            } else {
              swal("Error!", "Something went wrong. Please try again.", "warning");
            }
          });
      }
      else {
        swal('Error!', 'Please fill the details', 'warning')
      }

    } else {
      if (this.state.searchData.crewId !== "" && this.state.searchData.name !== "" && this.state.searchData.designation !== "" && this.state.searchData.photoName !== "") {
        let data = {
          shipName: userRole == Role.mmpladmin ? this.state.searchData.shipName : userRole == Role.staff ? ShipNameList[0]?.shipName : shipInfo.shipName,
          crewId: this.state.searchData.crewId,
          shipId: userRole == Role.mmpladmin ? this.state.searchData.shipId : userRole == Role.staff ? ShipNameList[0]?.shipID : shipInfo.shipId,
          name: this.state.searchData.name,
          designation: this.state.searchData.designation,
          photo: this.state.searchData.photo,
          photoName: this.state.searchData.photoName,
          createdBy: this.state.user.email,
        };

        let url = `${API.PostCrew}`;
        axios
          .post(url, data)
          .then((response) => {
            if (response.status === 500) {
              swal("Error!", "Error when adding the data. Try again.", "warning");
            } else {
              dispatch(searchCrewMgmt(SearchItem, 1));
              this.moveClientList();
              toast.success("Added Successfully", {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            }
          })
          .catch((error) => {
            swal("Error!", "Something went wrong. Please try again.", "warning");
            console.log("Error in Add new Crew" + error);
          });
      }
      else {
        swal('Error!', 'Please fill the details', 'warning')
      }
    }

  };

  ClearInput = () => {
    this.state.searchData.photoName = "";
    this.state.searchData.photo = "";
    this.state.PhotoFile = "";
    this.setState({});
  };

  renderShipNameTitle(state, val) {
    return (state?.shipName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  renderRankTitle(state, val) {
    return (state?.rankName || "").toLowerCase().indexOf((val || "").toLowerCase()) !== -1;
  }

  handleAnnualSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e.target.value;
    this.setState({});
  };

  handleAnnualSelectChange = (e, id) => {
    const { dispatch } = this.props;
    this.state.searchData.shipName = e;
    this.state.searchData.shipId = id;
    this.setState({});
  };

  handleAnnualRankSearchChange = (e) => {
    const { dispatch } = this.props;
    this.state.searchData.designation = e.target.value;
    this.setState({});
  };

  handleAnnualRankSelectChange = (e, id) => {
    const { dispatch } = this.props;
    let url = `${API.RankExist}?rankId=${id}`;
    axios.get(url)
      .then((response) => {
        if (response.data === false) {
          this.state.searchData.designation = e;
          this.setState({});
        }
        else {
          toast.error("Rank already used", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        }
        dispatch({
          type: "getRankExistSuccess",
          data: response.data
        })
      })
      .catch((error) => {
        dispatch({
          type: "getRankExistFailure",
          error: "ERROR"
        })
      })
  };
  BacktoPrevious() {
    this.props.history.goBack();
  }

  render() {
    const { ShipNameList, showSidePane, AllRank } = this.props;
    let ScreenWidth = window.innerWidth;
    // let user = JSON.parse(localStorage.getItem("currentUser"));
    return (
      <>
        {$("#imageCropModal").hasClass("show") ? (
          <div className="viewbar-overlay"></div>
        ) : (
          <></>)}
        <div className="full-height" id="addcrewcard">
          <div className="pt-3">
            <div className="row px-3 pb-3">
              <button
                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                onClick={() => this.BacktoPrevious()}
              >
                <div style={{ position: 'relative' }}>
                  <span className="backarr">&larr;</span> <span style={{ marginLeft: "18px" }}>Back</span>
                </div>
              </button>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="panel-box">
                  <div
                    className="card MM-card-header mt-2 mb-0"
                    style={{ backgroundColor: "white", border: "0px" }}
                  >
                    <div className="card-body">
                      <h5
                        className="card-title ml-4 mt-2"
                        style={{ color: "092a51" }}
                      >
                        Add Crew Member
                      </h5>
                    </div>
                  </div>
                  <div className="search-filter-box">
                    <div className="row pb-3">
                      <div className="col-sm-2 m-auto text-right">
                        <div className="text-center rounded-circle">
                          <img
                            src={
                              this.state.PhotoFile !== ""
                                ? this.state.PhotoFile
                                : logo
                            }
                            alt="Smiley face"
                            style={{ width: "145px", height: "140px" }}
                            class="rounded-circle"
                          ></img>
                        </div>
                      </div>
                      <div className="col-sm-10">
                        <div className="row">
                          <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                            <label className="form-label">Crew Id<span className="mandatory">*</span></label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name="crewId"
                              placeholder="Crew Id"
                              value={this.state.searchData.crewId}
                              onChange={(e) => this.handleInputChange(e)}
                            ></input>
                          </div>
                          <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                            <label className="form-label">Name<span className="mandatory">*</span></label>
                            <br></br>
                            <input
                              className="form-control"
                              type="text"
                              name="name"
                              placeholder="Name"
                              value={this.state.searchData.name}
                              onChange={(e) => this.handleInputChange(e)}
                            ></input>
                          </div>
                          {userRole === Role.mmpladmin || userRole === Role.staff ? (
                            userRole === Role.mmpladmin ?
                              <div
                                className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                                <div
                                  className="autocomplete-wrappers"
                                /* style={{ zIndex: 9999 }} */
                                >
                                  <label className="form-label">Ship Name<span className="mandatory">*</span></label>
                                  <br></br>
                                  <Autocomplete
                                    contentEditable={true}
                                    value={this.state.searchData.shipName}
                                    inputProps={{
                                      placeholder: "Ship Name",
                                    }}
                                    items={ShipNameList ?? []}
                                    getItemValue={(item) => item.shipName}
                                    shouldItemRender={this.renderShipNameTitle.bind(
                                      this
                                    )}
                                    renderMenu={(item) => (
                                      <div className="dropdown">{item}</div>
                                    )}
                                    renderItem={(item, isHighlighted) => (
                                      <div
                                        className={`items ${isHighlighted ? "selected-items" : ""
                                          }`}
                                      >
                                        {item.shipName}
                                      </div>
                                    )}
                                    onChange={(e) => this.handleAnnualSearchChange(e)}
                                    onSelect={(e, item) => this.handleAnnualSelectChange(e, item.shipID)}
                                  />
                                </div>
                              </div> :
                              userRole === Role.staff ?
                                <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                                  <div className="autocomplete-wrappers">
                                    <label className="form-label">Ship Name<span className="mandatory">*</span></label>
                                    <br></br>
                                    <Autocomplete
                                      contentEditable={true}
                                      value={ShipNameList ? ShipNameList[0]?.shipName : ""}
                                      inputProps={{ placeholder: "Ship Name", }}
                                      renderInput={(props) => {
                                        return (<input disabled={true}{...props} />);
                                      }}
                                      items={ShipNameList ?? []}
                                      getItemValue={(item) => item.shipName}
                                      shouldItemRender={this.renderShipNameTitle.bind(this)}
                                      renderMenu={(item) => (
                                        <div className="dropdown">{item}</div>
                                      )}
                                      renderItem={(item, isHighlighted) => (
                                        <div className={`items ${isHighlighted ? "selected-items" : ""}`}>
                                          {item.shipName}
                                        </div>
                                      )}
                                      onChange={(e) => this.handleAnnualSearchChange(e)}
                                      onSelect={(e, item) => this.handleAnnualSelectChange(e, item.shipID)}
                                    />
                                  </div>
                                </div> : <></>
                          ) : null}
                          {/* <div className={showSidePane ? "col-lg-4 " : "col-lg-4 "}>
                        <label className="form-label">Rank</label>
                        <br></br>
                        <input
                          className="form-control"
                          type="text"
                          name="designation"
                          placeholder="Rank"
                          value={this.state.searchData.designation}
                          onChange={(e) => this.handleInputChange(e)}
                        ></input>
                      </div> */}
                          <div
                            className={showSidePane ? "col-lg-4 " : "col-lg-4 "}
                          >
                            <div
                              className="autocomplete-wrappers"
                            // style={{ zIndex: 9999 }}
                            >
                              <label className="form-label">Rank<span className="mandatory">*</span></label>
                              <br></br>
                              <Autocomplete
                                contentEditable={true}
                                value={this.state.searchData.designation}
                                inputProps={{
                                  placeholder: "Rank",
                                }}
                                items={AllRank ?? []}
                                getItemValue={(item) => item.rankName}
                                shouldItemRender={this.renderRankTitle.bind(
                                  this
                                )}
                                renderMenu={(item) => (
                                  <div className="dropdown">{item}</div>
                                )}
                                renderItem={(item, isHighlighted) => (
                                  <div
                                    className={`items ${isHighlighted ? "selected-items" : ""
                                      }`}
                                  >
                                    {item.rankName}
                                  </div>
                                )}
                                onChange={(e) => this.handleAnnualRankSearchChange(e)}
                                onSelect={(e, item) => this.handleAnnualRankSelectChange(e, item.rankId)}
                              />
                            </div>
                          </div>
                          <div className="col-lg-4">
                            <label className="form-label">Photo<span className="mandatory">*</span></label>
                            <br></br>
                            <div class="input-group">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  Browse File
                                  <input
                                    type="file"
                                    id="files"
                                    title=" "
                                    name="attachmentName"
                                    style={{ marginRight: 40 }}
                                    onChange={(e) => this.handleInputFileChange(e)}
                                    onClick={(event) => {
                                      event.currentTarget.value = null;
                                    }}
                                  />
                                </span>
                              </div>
                              <input
                                type="text"
                                class="form-control"
                                placeholder=""
                                value={this.state.searchData.photoName}
                              />
                              {this.state.searchData.photoName ? (
                                <div class="input-group-append"
                                  style={{ cursor: "pointer" }}>
                                  <i
                                    class="fa fa-times input-group-text"
                                    aria-hidden="true"
                                    onClick={() => this.ClearInput()}
                                  ></i>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className={userRole == Role.staff ? "col-lg-4 pt-3" : "col-lg-4 pt-3"}>
                            <br></br>
                            <div
                              className="search-btn-col"
                              style={{ textAlign: "end" }}
                            >
                              <button
                                className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                                type="submit"
                                onClick={() => this.SubmitCrew()}
                              >
                                {" "}
                                Submit{" "}
                              </button>
                              <button
                                className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                                type="button"
                                onClick={() => this.moveClientList()}
                              >
                                {" "}
                                Cancel{" "}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
        <div>
          <Modal
            size="lg"
            show={this.state.modalIsOpen}
            onHide={() => this.setState({ modalIsOpen: false })}
            aria-labelledby="example-modal-sizes-title-sm"
            backdrop="static"
            centered="true"
            animation="true"
          >
            <Modal.Header closeButton>
              Upload crew image
            </Modal.Header>

            <Modal.Body>
              <Demo imageBlob={this.state.ImgSrc} handleImgCrop={this.propsImgSrc} />
            </Modal.Body>
          </Modal>
        </div>

      </>

    );
  }

  moveClientList = () => {
    if (userRole == Role.staff) {
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/CrewManagement");
    } else {
      this.props.dispatch({ type: "ShowSidePan", data: false });
      this.props.history.push("/Home/Management/CrewManagement");
    }
  };
}

function mapStateToProps(state) {
  return {
    showSidePane: state.SidePanReducer.sidePan || false,
    ShipNameList: state.UserManageReducer.ShipNameList,
    UsersList: state.UserManageReducer.UsersList,
    shipInfo: state.SidePanReducer.shipInfo,
    AllRank: state.RankManagementReducer.AllRank,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(AddCrewMember)
);
